// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ImportProgressFields_EmployeeExportProgress_Fragment = { __typename?: 'EmployeeExportProgress' } & Pick<
  Types.EmployeeExportProgress,
  'id' | 'status' | 'createdAt' | 'updatedAt' | 'totalRequestCount' | 'completedRequestCount'
> & {
    createdBy: Types.Maybe<
      { __typename?: 'Employee' } & {
        generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
          Types.EmployeeGeneralInformation,
          'preferredFullName'
        >;
      }
    >;
  };

export type ImportProgressFields_EmployeeImportProgress_Fragment = { __typename?: 'EmployeeImportProgress' } & Pick<
  Types.EmployeeImportProgress,
  'id' | 'status' | 'createdAt' | 'updatedAt' | 'totalRequestCount' | 'completedRequestCount'
> & {
    createdBy: Types.Maybe<
      { __typename?: 'Employee' } & {
        generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
          Types.EmployeeGeneralInformation,
          'preferredFullName'
        >;
      }
    >;
  };

export type ImportProgressFields_ExternalAccountExportProgress_Fragment = {
  __typename?: 'ExternalAccountExportProgress';
} & Pick<
  Types.ExternalAccountExportProgress,
  'id' | 'status' | 'createdAt' | 'updatedAt' | 'totalRequestCount' | 'completedRequestCount'
> & {
    createdBy: Types.Maybe<
      { __typename?: 'Employee' } & {
        generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
          Types.EmployeeGeneralInformation,
          'preferredFullName'
        >;
      }
    >;
  };

export type ImportProgressFields_ManagerialAccountingImportProgress_Fragment = {
  __typename?: 'ManagerialAccountingImportProgress';
} & Pick<
  Types.ManagerialAccountingImportProgress,
  'id' | 'status' | 'createdAt' | 'updatedAt' | 'totalRequestCount' | 'completedRequestCount'
> & {
    createdBy: Types.Maybe<
      { __typename?: 'Employee' } & {
        generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
          Types.EmployeeGeneralInformation,
          'preferredFullName'
        >;
      }
    >;
  };

export type ImportProgressFields_NumberOfEmployeeExportProgress_Fragment = {
  __typename?: 'NumberOfEmployeeExportProgress';
} & Pick<
  Types.NumberOfEmployeeExportProgress,
  'id' | 'status' | 'createdAt' | 'updatedAt' | 'totalRequestCount' | 'completedRequestCount'
> & {
    createdBy: Types.Maybe<
      { __typename?: 'Employee' } & {
        generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
          Types.EmployeeGeneralInformation,
          'preferredFullName'
        >;
      }
    >;
  };

export type ImportProgressFields_PerformanceReviewExportProgress_Fragment = {
  __typename?: 'PerformanceReviewExportProgress';
} & Pick<
  Types.PerformanceReviewExportProgress,
  'id' | 'status' | 'createdAt' | 'updatedAt' | 'totalRequestCount' | 'completedRequestCount'
> & {
    createdBy: Types.Maybe<
      { __typename?: 'Employee' } & {
        generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
          Types.EmployeeGeneralInformation,
          'preferredFullName'
        >;
      }
    >;
  };

export type ImportProgressFields_ProbationReviewExportProgress_Fragment = {
  __typename?: 'ProbationReviewExportProgress';
} & Pick<
  Types.ProbationReviewExportProgress,
  'id' | 'status' | 'createdAt' | 'updatedAt' | 'totalRequestCount' | 'completedRequestCount'
> & {
    createdBy: Types.Maybe<
      { __typename?: 'Employee' } & {
        generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
          Types.EmployeeGeneralInformation,
          'preferredFullName'
        >;
      }
    >;
  };

export type ImportProgressFieldsFragment =
  | ImportProgressFields_EmployeeExportProgress_Fragment
  | ImportProgressFields_EmployeeImportProgress_Fragment
  | ImportProgressFields_ExternalAccountExportProgress_Fragment
  | ImportProgressFields_ManagerialAccountingImportProgress_Fragment
  | ImportProgressFields_NumberOfEmployeeExportProgress_Fragment
  | ImportProgressFields_PerformanceReviewExportProgress_Fragment
  | ImportProgressFields_ProbationReviewExportProgress_Fragment;

export type ImportProgressSubscriptionVariables = Types.Exact<{ [key: string]: never }>;

export type ImportProgressSubscription = { __typename?: 'Subscription' } & {
  importProgress: Array<
    | ({ __typename: 'EmployeeExportProgress' } & ImportProgressFields_EmployeeExportProgress_Fragment)
    | ({ __typename: 'EmployeeImportProgress' } & ImportProgressFields_EmployeeImportProgress_Fragment)
    | ({ __typename: 'ExternalAccountExportProgress' } & ImportProgressFields_ExternalAccountExportProgress_Fragment)
    | ({
        __typename: 'ManagerialAccountingImportProgress';
      } & ImportProgressFields_ManagerialAccountingImportProgress_Fragment)
    | ({ __typename: 'NumberOfEmployeeExportProgress' } & ImportProgressFields_NumberOfEmployeeExportProgress_Fragment)
    | ({
        __typename: 'PerformanceReviewExportProgress';
      } & ImportProgressFields_PerformanceReviewExportProgress_Fragment)
    | ({ __typename: 'ProbationReviewExportProgress' } & ImportProgressFields_ProbationReviewExportProgress_Fragment)
  >;
};

export const ImportProgressFieldsFragmentDoc = /*#__PURE__*/ gql`
    fragment ImportProgressFields on ExportImportProgress {
  id
  status
  createdAt
  updatedAt
  createdBy {
    generalInformation {
      preferredFullName
    }
  }
  totalRequestCount
  completedRequestCount
}
    `;
export const ImportProgressDocument = /*#__PURE__*/ gql`
    subscription importProgress {
  importProgress {
    __typename
    ...ImportProgressFields
  }
}
    ${ImportProgressFieldsFragmentDoc}`;

/**
 * __useImportProgressSubscription__
 *
 * To run a query within a React component, call `useImportProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useImportProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportProgressSubscription({
 *   variables: {
 *   },
 * });
 */
export function useImportProgressSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<ImportProgressSubscription, ImportProgressSubscriptionVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<ImportProgressSubscription, ImportProgressSubscriptionVariables>(
    ImportProgressDocument,
    options,
  );
}
export type ImportProgressSubscriptionHookResult = ReturnType<typeof useImportProgressSubscription>;
